import React, { createContext, useContext, useState } from 'react';

const CopyPasteContext = createContext();

export const useCopyPaste = () => {
  const context = useContext(CopyPasteContext);
  if (!context) {
    throw new Error('useCopyPaste must be used within a CopyPasteProvider');
  }
  return context;
};

export const CopyPasteProvider = ({ children }) => {
  const [copiedTask, setCopiedTask] = useState(null);

  const copyTask = (taskData) => {
    // Erstelle eine Kopie der Task-Daten ohne ID aber behalte UUID für das Kopieren der Zuordnungen
    const taskCopy = {
      ...taskData,
      id: undefined, // Wird beim Einfügen neu generiert
      originalUuid: taskData.uuid, // Behalte Original-UUID für das Kopieren der Zuordnungen
      uuid: undefined, // UUID wird beim Einfügen neu generiert
      label: `${taskData.label} (Kopie)` // Kennzeichne als Kopie
    };
    setCopiedTask(taskCopy);
  };

  const pasteTask = () => {
    if (copiedTask) {
      return { ...copiedTask }; // Gib eine neue Kopie zurück
    }
    return null;
  };

  const clearCopiedTask = () => {
    setCopiedTask(null);
  };

  const hasCopiedTask = () => {
    return copiedTask !== null;
  };

  return (
    <CopyPasteContext.Provider 
      value={{ 
        copyTask, 
        pasteTask, 
        clearCopiedTask, 
        hasCopiedTask,
        copiedTask 
      }}
    >
      {children}
    </CopyPasteContext.Provider>
  );
};